$(() => {
    const escapeHtml = (value) => $('<div/>').text(value ?? '').html()

    const formatEntityOption = (state, compact = false) => {
        if (!state.id) {
            return escapeHtml(state.text)
        }

        const $option = state.element ? $(state.element) : null
        const thumbnail = state.thumbnail || ($option ? $option.data('thumbnail') : '') || ''
        const name = escapeHtml(state.text || state.name || '')
        const compactClass = compact ? ' warehouse-stock-entity-option--compact' : ''

        if (!thumbnail) {
            return name
        }

        return $(
            `<span class="warehouse-stock-entity-option${compactClass}">` +
                `<img src="${escapeHtml(thumbnail)}" alt="" class="warehouse-stock-entity-option__image" loading="lazy" />` +
                `<span class="warehouse-stock-entity-option__name">${name}</span>` +
            `</span>`,
        )
    }

    const entitySelectConfig = () => ({
        escapeMarkup: (markup) => markup,
        templateResult: (state) => formatEntityOption(state, false),
        templateSelection: (state) => formatEntityOption(state, true),
    })

    const showModal = ($modal) => {
        if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            bootstrap.Modal.getOrCreateInstance($modal[0]).show()

            return
        }

        if ($.fn.modal) {
            $modal.modal('show')
        }
    }

    const hideModal = ($modal) => {
        if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            bootstrap.Modal.getInstance($modal[0])?.hide()

            return
        }

        if ($.fn.modal) {
            $modal.modal('hide')
        }
    }

    const postForm = ($form, $button) => {
        const request = $httpClient
            ? $httpClient.make().withButtonLoading($button).post($form.prop('action'), $form.serialize())
            : $.ajax({
                url: $form.prop('action'),
                type: 'POST',
                data: $form.serialize(),
                beforeSend: () => $button.prop('disabled', true).addClass('btn-loading'),
            }).always(() => $button.prop('disabled', false).removeClass('btn-loading'))

        return Promise.resolve(request).then((response) => response?.data ?? response)
    }

    const initBulkProductList = ($container) => {
        const loadUrl = $container.data('load-url')
        const $form = $container.closest('form')
        const fixedStoreId = $container.data('store-id') || $form.find('input[name="store_id"]').val()
        let products = []
        let request = null

        const renderList = () => {
            if (!products.length) {
                $container.html(`
                    <div class="warehouse-stock-products__placeholder text-muted py-5 text-center">
                        <div>${escapeHtml($container.data('no-products-message'))}</div>
                    </div>
                `)

                return
            }

            const quantityLabel = escapeHtml($container.data('quantity-label'))
            const productLabel = escapeHtml($container.data('product-label'))
            const countLabel = String($container.data('products-count-label') || '').replace(':count', products.length)
            const quantityHint = escapeHtml($container.data('quantity-hint'))

            let html = `
                <div class="warehouse-stock-products__panel">
                    <div class="warehouse-stock-products__summary">
                        <span class="warehouse-stock-products__summary-count">${escapeHtml(countLabel)}</span>
                        <span class="warehouse-stock-products__summary-hint">${quantityHint}</span>
                    </div>
                    <div class="warehouse-stock-products__head">
                        <div>${productLabel}</div>
                        <div class="text-center">${quantityLabel}</div>
                    </div>
                    <div class="warehouse-stock-products__list">
            `

            products.forEach((product, index) => {
                const meta = product.sku ? `SKU: ${product.sku}` : '&mdash;'

                html += `
                    <div class="warehouse-stock-product-item">
                        <div class="warehouse-stock-product-item__info">
                            <img src="${escapeHtml(product.thumbnail)}" alt="${escapeHtml(product.name)}" class="warehouse-stock-product-item__thumb" loading="lazy" />
                            <div class="min-w-0">
                                <div class="warehouse-stock-product-item__name">${escapeHtml(product.name)}</div>
                                <div class="warehouse-stock-product-item__meta">${meta}</div>
                            </div>
                        </div>
                        <div class="warehouse-stock-product-item__quantity" data-label="${quantityLabel}">
                            <input
                                type="number"
                                class="form-control"
                                name="items[${index}][quantity]"
                                min="0"
                                max="${product.available_quantity}"
                                value="0"
                                inputmode="numeric"
                                aria-label="${quantityLabel} - ${escapeHtml(product.name)}"
                            />
                            <input type="hidden" name="items[${index}][product_id]" value="${product.id}" />
                        </div>
                    </div>
                `
            })

            html += '</div></div>'

            $container.html(html)
        }

        const showPlaceholder = (message, loading = false) => {
            const loadingMarkup = loading
                ? '<div class="spinner-border spinner-border-sm text-secondary mb-2" role="status"></div>'
                : ''

            $container.html(`
                <div class="warehouse-stock-products__placeholder text-muted py-5 text-center">
                    ${loadingMarkup}
                    <div>${escapeHtml(message)}</div>
                </div>
            `)
        }

        const loadProducts = () => {
            if (!fixedStoreId) {
                showPlaceholder($container.data('select-store-message'))

                return
            }

            if (request) {
                request.abort()
            }

            showPlaceholder($container.data('loading-message'), true)

            request = $.ajax({
                url: loadUrl,
                type: 'GET',
                success: (response) => {
                    products = Array.isArray(response.data) ? response.data : []
                    renderList()
                },
                error: (xhr) => {
                    if (xhr.statusText === 'abort') {
                        return
                    }

                    const message = xhr.responseJSON?.message || 'Failed to load products.'
                    showPlaceholder(message)
                },
                complete: () => {
                    request = null
                },
            })
        }

        loadProducts()
    }

    const reloadStockTable = () => {
        const $table = $('.stock-management .table-wrapper table')

        if (!$table.length) {
            return
        }

        const tableId = $table.attr('id')

        if (tableId && window.LaravelDataTables && window.LaravelDataTables[tableId]) {
            window.LaravelDataTables[tableId].draw(false)

            return
        }

        $('.stock-management .buttons-reload').trigger('click')
    }

    const initWithdrawModal = () => {
        const $modal = $('#withdraw-warehouse-stock-modal')

        if (!$modal.length) {
            return
        }

        const $config = $modal.find('.warehouse-stock-withdraw-config')
        const $form = $modal.find('#withdraw-warehouse-stock-form')
        const $sourceWarehouseSelect = $modal.find('.warehouse-stock-transfer-source-select')
        const $destinationWarehouseSelect = $modal.find('.warehouse-stock-transfer-destination-select')
        const $productSelect = $modal.find('.warehouse-stock-withdraw-product-select')
        const $quantityInput = $modal.find('.warehouse-stock-withdraw-quantity')
        const loadProductsUrl = $config.data('load-products-url')
        let products = []
        let productsRequest = null

        const destroyProductSelect = () => {
            if ($productSelect.hasClass('select2-hidden-accessible')) {
                $productSelect.select2('destroy')
            }
        }

        const initProductSelect = () => {
            destroyProductSelect()

            if ($productSelect.prop('disabled')) {
                return
            }

            Botble.select(
                $productSelect[0],
                {
                    placeholder: $config.data('select-product-message'),
                    width: '100%',
                    allowClear: true,
                    dropdownParent: $modal,
                    ...entitySelectConfig(),
                },
                true,
            )
        }

        const resetProductSelect = (message) => {
            destroyProductSelect()

            $productSelect
                .empty()
                .append($('<option/>', { value: '', text: message }))
                .prop('disabled', true)
                .val('')

            $quantityInput.prop('disabled', true).val(1).removeAttr('max')
        }

        const populateProducts = () => {
            destroyProductSelect()

            $productSelect.empty().append(
                $('<option/>', { value: '', text: $config.data('select-product-message') }),
            )

            products.forEach((product) => {
                $productSelect.append(
                    $('<option/>', {
                        value: product.id,
                        text: product.name,
                    })
                        .attr('data-thumbnail', product.thumbnail || '')
                        .attr('data-available-quantity', product.available_quantity),
                )
            })

            $productSelect.prop('disabled', !products.length).val('')
            initProductSelect()
            $quantityInput.prop('disabled', true).val(1).removeAttr('max')
        }

        const loadWithdrawProducts = () => {
            const sourceWarehouseId = $sourceWarehouseSelect.val()

            if (!sourceWarehouseId) {
                resetProductSelect($config.data('select-source-message'))

                return
            }

            if (productsRequest) {
                productsRequest.abort()
            }

            resetProductSelect($config.data('loading-message'))

            productsRequest = $.ajax({
                url: loadProductsUrl,
                type: 'GET',
                data: {
                    source_warehouse_id: sourceWarehouseId,
                },
                success: (response) => {
                    products = Array.isArray(response.data) ? response.data : []

                    if (!products.length) {
                        resetProductSelect($config.data('no-products-message'))

                        return
                    }

                    populateProducts()
                },
                error: (xhr) => {
                    if (xhr.statusText === 'abort') {
                        return
                    }

                    const message = xhr.responseJSON?.message || $config.data('no-products-message')
                    resetProductSelect(message)
                },
                complete: () => {
                    productsRequest = null
                },
            })
        }

        $productSelect.on('change', function () {
            const $selected = $(this).find(':selected')
            const available = parseInt($selected.data('available-quantity') || 0, 10)

            if (!$(this).val() || available <= 0) {
                $quantityInput.prop('disabled', true).val(1).removeAttr('max')

                return
            }

            $quantityInput.prop('disabled', false).attr('max', available).val(Math.min(1, available))
        })

        $sourceWarehouseSelect.on('change', () => {
            loadWithdrawProducts()
        })

        $modal.on('show.bs.modal', loadWithdrawProducts)
        $modal.on('hidden.bs.modal', () => {
            if (productsRequest) {
                productsRequest.abort()
                productsRequest = null
            }

            products = []
            $sourceWarehouseSelect.val('')
            $destinationWarehouseSelect.val('')
            resetProductSelect($config.data('loading-message'))
        })

        $(document).on('click', '#confirm-withdraw-warehouse-stock-button', (event) => {
            event.preventDefault()

            const $button = $(event.currentTarget)

            if ($sourceWarehouseSelect.val() && $sourceWarehouseSelect.val() === $destinationWarehouseSelect.val()) {
                Botble.showError('Source warehouse and destination warehouse must be different.')

                return
            }

            postForm($form, $button).then((data) => {
                if (data.error) {
                    Botble.showError(data.message)

                    return
                }

                hideModal($modal)
                Botble.showSuccess(data.message)
                reloadStockTable()
            })
        })
    }

    $('.warehouse-stock-products').each(function () {
        initBulkProductList($(this))
    })

    initWithdrawModal()
})
